const MODAL_VIEW_TYPES = {
  SHEET: 'SHEET',
  DIALOG: 'DIALOG',
};

const MODAL_SIZE = {
  DEFAULT: 'DEFAULT',
  LARGE: 'LARGE',
  SMALL: 'SMALL',
};

export { MODAL_VIEW_TYPES, MODAL_SIZE };
